// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import config from './config';
import graphic from './graphic';

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();
};

async function draw(initialWidth) {
  const container = select('#graphic');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  const heightMultiplier = isMobile ? 1 : 9 / 16;
  const initialHeight = heightMultiplier * safeWidth;

  const props = { initialWidth: safeWidth, initialHeight, isMobile };

  const graphicConfig = config(props);

  // Await the async graphic function and get returned metadata
  const metadata = await graphic(graphicConfig, container, isMobile);

  // Populate dek with dynamic values from JSON
  const dekElement = document.querySelector('.dek');
  if (dekElement && metadata) {
    const totalInK = metadata.totalDetainees / 1000;
    const totalFormatted = `${totalInK % 1 === 0 ? totalInK.toFixed(0) : totalInK.toFixed(1)}K`;
    const latestDate = new Date(metadata.lastUpdated).toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    const pctTrumpChg = Math.round(metadata.pctIncreaseTrump);
    dekElement.innerHTML = `About ${totalFormatted} people were held in detention as of ${latestDate}, according to the latest data available from the Transactional Records Access Clearinghouse, a nonpartisan data research organization that tracks immigration records. That's a ${pctTrumpChg}% increase from the start of President Donald Trump's second term.<br><br><b>Number of people detained by US Immigration and Customs Enforcement (ICE) and Customs and Border Protection (CBP)</b>`;
  }

  // Populate footnote with last updated date from JSON
  const footnoteElement = document.querySelector('.footnote');
  if (footnoteElement && metadata) {
    footnoteElement.innerHTML = `Data last updated ${metadata.lastUpdatedStr}`;
  }

  // Send updated height to parent after graphic renders
  if (window.pymChild) {
    window.pymChild.sendHeight();
  }
}
